webpackJsonp([245511695889389],{

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(148);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(80);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _voucherAd = __webpack_require__(154);
	
	var _voucherAd2 = _interopRequireDefault(_voucherAd);
	
	var _siteConfig = __webpack_require__(65);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CorpPage = function CorpPage() {
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: _siteConfig2.default.siteName + ' | Corporate Days | ' + _siteConfig2.default.siteTitleAlt,
	      meta: [{
	        name: 'description',
	        content: 'Get out of the office for a day and book a corporate 4x4 off roading package today to help build team work and reward your employees whilst having fun driving on our specially designed off roading courses.'
	      }]
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'corp banner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'banner-info top-off-center text-center' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'uppercase' },
	          'Corporate day professional training'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'spacer white hide-for-small-only' },
	          '\u2015'
	        ),
	        _react2.default.createElement(
	          'h5',
	          { className: 'hide-for-small-only' },
	          'Packages from \xA3100 per person'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button secondary uppercase large hide-for-small-only', href: '/bookings' },
	          'Bookings'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'small-12 medium-10 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-header' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'uppercase' },
	              'Corporate & Team Building'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'large-9 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-body' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'subheader' },
	              'Build teamwork skills and reward your employees.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Our off road corporate days are a refreshing change from the everyday workplace. Whether you\'re entertaining special clients or looking to build rapport and break the ice with some new employees, we tailor your day to suit you and your company.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'A chance for some healthy competition on our specially built Trials course and some all-important communication development between team members during our Off Road games. We give your team a shared experience they\'ll never forget.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Our off-road experience days can:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Improve team communication'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Practise problem solving'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Encourage thinking "outside the box"'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Reward & Motivate your employees'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Create a shared experience'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Corporate days can be run during normal working hours and in any weather.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Packages start from \xA3100 per person.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'aside',
	          { className: 'large-3 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-body' },
	            _react2.default.createElement(_voucherAd2.default, null)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = CorpPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-corporate-js-04ccfc3a6f29d0d0f3a6.js